module.exports = __webpack_public_path__ + "static/media/egg.669e7fc6.svg";